module.exports = __webpack_public_path__ + "static/21-36a9c3810bf2fbfe8c0126977a694981.jpg";